import { lazy } from "react";

// const PatientBalanceDashboard = lazy(() => import("pages/provider/PatientBalanceDashboard"));
const PatientTabDashboard = lazy(() => import("pages/provider/PatientTabDashboard"));
const PatientBalanceReminders = lazy(() => import("pages/provider/PatientBalanceReminders"));

const patientBalance = [
  {
    path: "/patient-balance-dashboard",
    isExact: false,
    component: PatientTabDashboard,
  },
  {
    path: "/patient-balance-reminders",
    isExact: true,
    component: PatientBalanceReminders,
  },
];

export default patientBalance;
